import React from 'react';
import { exponentialPosition, getScaledColor } from '../utils/positionUtils';
import './FunnelWeight.css';

interface FunnelWeightProps {
  awareness: number;
  consideration: number;
  preference: number;
  actionIntent: number;
  benchmarkAwareness?: number;
  benchmarkConsideration?: number;
  benchmarkPreference?: number;
  benchmarkActionIntent?: number;
}

const FunnelWeight: React.FC<FunnelWeightProps> = ({
  awareness,
  consideration,
  preference,
  actionIntent,
  benchmarkAwareness = 100,
  benchmarkConsideration = 100,
  benchmarkPreference = 100,
  benchmarkActionIntent = 100
}) => {
  const renderMetric = (
    label: string,
    value: number,
    benchmark: number
  ) => {
    // Position marker based on benchmark.funnel value using exponential function
    // The benchmark line stays at 50% (representing 100)
    // The marker shows where the benchmark.funnel value sits on the scale
    const markerPosition = exponentialPosition(benchmark);
    // Use scaled color based on marker position (0-100)
    const color = getScaledColor(markerPosition);
    
    return (
      <div key={label} className="funnel-metric">
        <div className="funnel-metric-label">{label}</div>
        <div className="funnel-metric-bar-container">
          <div className="funnel-metric-bar">
            {/* Benchmark line at 50% (middle) - represents 100 as reference */}
            <div 
              className="funnel-benchmark-line"
              style={{ left: '50%' }}
            />
            {/* Value marker positioned based on benchmark.funnel value */}
            <div
              className="funnel-value-marker"
              style={{
                left: `${markerPosition}%`,
                backgroundColor: color
              }}
            />
          </div>
        </div>
        <div className="funnel-metric-value" style={{ color }}>
          {Math.round(benchmark)}
        </div>
      </div>
    );
  };

  return (
    <div className="funnel-weight">
      {renderMetric('Awareness', awareness, benchmarkAwareness)}
      {renderMetric('Consideration', consideration, benchmarkConsideration)}
      {renderMetric('Preference', preference, benchmarkPreference)}
      {renderMetric('Action Intent', actionIntent, benchmarkActionIntent)}
    </div>
  );
};

export default FunnelWeight;
